import { render, staticRenderFns } from "./teamCard.vue?vue&type=template&id=50f5d292&scoped=true&"
import script from "./teamCard.vue?vue&type=script&lang=js&"
export * from "./teamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5d292",
  null
  
)

export default component.exports